export enum AuthState {
  Anonymous = 'anonymous',
  Valid = 'valid',
  Refreshing = 'refreshing',
  Recovering = 'recovering',
  Revoked = 'revoked'
}
